var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ship-monitor-container"},[_c('ship-map-view',{ref:"shipMapView"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }